import React from 'react'
import ProductSupply from '../ProductSupply/ProductSupply';


function liftingRigging() {
  return (
    <div><ProductSupply 
    heading="Industrial Tools & Equipment" 
    paraContent="Discover a wide range of high-quality industrial tools and equipment designed for various applications."
  /></div>
  )
}

export default liftingRigging